(function() {
	'use strict';

	angular.module('paymentRates').factory('PaymentRatesFactory',
			PaymentRatesFactory);

	function PaymentRatesFactory() {

		function FlyingHourRatesFromResponse() {
			this.rangeTitle = null;
			this.fromHour = null;
			this.toHour = null;
			this.range = null;
			this.paymentHourRangeId = null;
			this.version = null;
			this.crewTypeCode = null;
		}

		function OtherPaymentRatesFromResponse() {
			this.crewType = null;
			this.paymentRateId = null;
			this.version = null;
			this.lineTraining = new lineTrainingRates();
			this.layOverDetails = new layOverDetails();
      this.hourlylayOverDetails = new hourlyLayOverDetails();
			this.groundDutyDetails = new groundDutyDetails();
			this.SIMHoursDetails = new SIMHoursDetails();
			this.deadHeadingDutyDetails = new deadHeadingDutyDetails();
			this.standByDutyDetails = new standByDutyDetails();
			this.leaveDetails = new leaveDetails();
			this.adHocDetails = new adHocDetails();

			this.cmbRate = null;
			this.simRate = null;
			this.sod = null;
			this.offRate = null;
		}

		function deadHeadingDutyDetails() {
			this.flightDutyDHDRange = 0;
			this.flightDutyDHDRangeUnit = '';
			this.heavyFlyingRange = 0;
			this.heavyFlyingRangeUnit = '';
			this.deadHeadingTravelRange = 0;
			this.deadHeadingTravelRangeUnit = '';
		}

		function standByDutyDetails() {
			this.airportStandByRange = 0;
			this.airportStandByRangeUnit = '';
			this.calledFromOFFRange = 0
		}

		function leaveDetails() {
			this.leaveDaysRange = 0;
			this.leavedaysRangeUnit = '';
		}

		function adHocDetails() {
			this.adhocRange = 0
		}

		function lineTrainingRates() {
			this.lineTrainingRange = 0;
			this.lineTrainingRangeUnit = ''

			this.LTLTCExperiencedRange = 0;
			this.LTLTCExperiencedRangeUnit = '';

			this.LTTRIExperiencedRange = 0;
			this.LTTRIExperiencedRangeUnit = '';

			this.LTTREExperiencedRange = 0;
			this.LTTREExperiencedRangeUnit = '';

			this.LTLTCInExperiencedRange = 0;
			this.LTLTCInExperiencedRangeUnit = '';

			this.LTTRIInExperiencedRange = 0;
			this.LTTRIInExperiencedRangeUnit = '';

			this.LTTREInExperiencedRange = 0;
			this.LTTREInExperiencedRangeUnit = '';
		}

		function layOverDetails() {
			this.domesticLayoverRateRange = 0;
      this.hourlyDomesticLayOverDetails = 0;
      this.internationalNightStopRate = 0;
      this.hourlyInternationalLayOverDetails
			this.layoverRateRangeUnit = '';
		}

    function hourlyLayOverDetails() {
      this.hourlyLayoverRateRange = 0;
      this.hourlyLayoverRateRangeUnit = '';
    }

		function groundDutyDetails() {
			this.GRDTrainingRange = 0;
			this.GRDTrainingRangeUnit = '';
			this.officeDutyRange = 0;
			this.officeDutyRangeUnit = '';
      this.GIOfficeTrainingRange = 0;
      this.GIOfficeTrainingRangeUnit = '';
      this.MaxPayOfficeDuties = 0;
      this.MaxPayOfficeDutiesUnit = '';
      this.MaxPayOfficeDutyHoursPerDay=0;
      this.MaxPayOfficeDutyHoursPerDayUnit='';
      this.groundTrainingRatePerDay=0;

      this.CabinSpecialDutyPerHour=0;
      this.CabinSupportActivityPerHour=0;

    }

		function SIMHoursDetails() {
			this.SIMFSIInExperiencedRange = 0;
			this.SIMFSIInExperiencedRangeUnit = '';

			this.SIMTRIInExperiencedRange = 0;
			this.SIMTRIInExperiencedRangeUnit = '';

			this.SIMTREInExperiencedRange = 0;
			this.SIMTREInExperiencedRangeUnit = '';

			this.SIMFSIExperiencedRange = 0;
			this.SIMFSIExperiencedRangeUnit = '';

			this.SIMTRIExperiencedRange = 0;
			this.SIMTRIExperiencedRangeUnit = '';

			this.SIMTREExperiencedRange = 0;
			this.SIMTREExperiencedRangeUnit = '';

			this.MFTDTrainerInExperiencedRange = 0;
			this.MFTDTrainerInExperiencedRangeUnit = '';

			this.MFTDTrainerExperiencedRange = 0;
			this.MFTDTrainerExperiencedRangeUnit = '';

		}

		function OtherPaymentRatesForSave() {
			this.paymentRateId = null;
			this.version = null;
			this.crewType = null;
			this.duty1 = null;
			this.offRate = null;
			this.cmbRate = null;
			this.ltRate = null;
			this.simRate = null;
			this.calledFromOffRate = null;
			this.grdRate = null;
			this.dhtRate = null;
      this.domesticNightStopRate = null;
      this.internationalNightStopRate = null;
      this.hourlyInternationalNightStopRate = null;
      this.hourlyDomesticNightStopRate = null;
			this.airPortSbyRate = null;
			this.leaveDays = null;
			this.sod = null;
			this.adHocPay = null;
			this.heavyFlyingRate = null;
			this.lt_LTC_LESS_EXP_Rate = null;
			this.lt_LTC_MORE_EXP_Rate = null;
			this.lt_TRI_MORE_EXP_Rate = null;
			this.lt_TRI_LESS_EXP_Rate = null;
			this.lt_TRE_LESS_EXP_Rate = null;
			this.lt_TRE_MORE_EXP_Rate = null;
			this.sim_SFI_LESS_EXP_Rate = null;
			this.sim_SFI_MORE_EXP_Rate = null;
			this.sim_TRI_LESS_EXP_Rate = null;
			this.sim_TRI_MORE_EXP_Rate = null;
			this.sim_TRE_MORE_EXP_Rate = null;
			this.sim_TRE_LESS_EXP_Rate = null;
			this.mftd_MORE_EXP_Rate = null;
			this.mftd_LESS_EXP_Rate = null;
			this.simStandinRate = null;
			this.maxPayOfficeDutyRate = null;
      this.maxPayOfficeDutyHoursPerDay=null;
      this.groundTrainingRatePerDay=null;
      this.cabinSpecialDutyRate=null;
      this.cabinSupportActivityRate=null;
		}

		function FlyingHourRatesForSaveRequest() {
			this.rangeTitle = null;
			this.rangeStartHour = null;
			this.rangeEndHour = null;
			this.flyHourRate = 0;
			this.paymentHourRangeId = null;
			this.version = null;
			this.crewTypeCode = null;
		}

		function FlyingHourRatesForDeleteRequest() {
			this.paymentHourRangeId = null;
			this.version = null;
		}

		function FormatFlyingHourRatesResponse(response) {
			var formattedList = [];
			angular.forEach(response, function(data) {
				var tmpData = new FlyingHourRatesFromResponse();
				tmpData.rangeTitle = data.rangeTitle;
				tmpData.fromHour = data.rangeStartHour;
				tmpData.toHour = data.rangeEndHour;
				tmpData.range = data.flyHourRate;
				tmpData.paymentHourRangeId = data.paymentHourRangeId;
				tmpData.version = data.version;
				tmpData.crewTypeCode = data.crewTypeCode;

				formattedList.push(tmpData);
			});
			return formattedList;
		}

		function FormatOtherPaymentRatesResponse(response) {
			var formattedData = new OtherPaymentRatesFromResponse();

			// line training
			formattedData.lineTraining.lineTrainingRange = response.ltRate;
			formattedData.lineTraining.LTLTCExperiencedRange = response.lt_LTC_MORE_EXP_Rate;
			formattedData.lineTraining.LTTRIExperiencedRange = response.lt_TRI_MORE_EXP_Rate;
			formattedData.lineTraining.LTTREExperiencedRange = response.lt_TRE_MORE_EXP_Rate;
			formattedData.lineTraining.LTLTCInExperiencedRange = response.lt_LTC_LESS_EXP_Rate;
			formattedData.lineTraining.LTTRIInExperiencedRange = response.lt_TRI_LESS_EXP_Rate;
			formattedData.lineTraining.LTTREInExperiencedRange = response.lt_TRE_LESS_EXP_Rate;

			// layover
			formattedData.layOverDetails.domesticLayoverRateRange = response.domesticNightStopRate;
      formattedData.layOverDetails.hourlyDomesticLayOverDetails = response.hourlyDomesticNightStopRate;
      formattedData.layOverDetails.internationalLayoverRate = response.internationalNightStopRate;
      formattedData.layOverDetails.hourlyInternationalLayOverDetails = response.hourlyInternationalNightStopRate;
      formattedData.layOverDetails.hourlyDomesticPerDiemRate = response.hourlyDomesticPerDiemRate;
      formattedData.layOverDetails.hourlyInternationalPerDiemRate = response.hourlyInternationalPerDiemRate;

			// SIMHoursDetails
			formattedData.SIMHoursDetails.SIMFSIInExperiencedRange = response.sim_SFI_LESS_EXP_Rate;
			formattedData.SIMHoursDetails.SIMTRIInExperiencedRange = response.sim_TRI_LESS_EXP_Rate;
			formattedData.SIMHoursDetails.SIMTREInExperiencedRange = response.sim_TRE_LESS_EXP_Rate;
			formattedData.SIMHoursDetails.SIMFSIExperiencedRange = response.sim_SFI_MORE_EXP_Rate;
			formattedData.SIMHoursDetails.SIMTRIExperiencedRange = response.sim_TRI_MORE_EXP_Rate;
			formattedData.SIMHoursDetails.SIMTREExperiencedRange = response.sim_TRE_MORE_EXP_Rate;
			formattedData.SIMHoursDetails.MFTDTrainerInExperiencedRange = response.mftd_LESS_EXP_Rate;
			formattedData.SIMHoursDetails.MFTDTrainerExperiencedRange = response.mftd_MORE_EXP_Rate;

			// groundDutyDetails
			formattedData.groundDutyDetails.GRDTrainingRange = response.grdRate;
			formattedData.groundDutyDetails.officeDutyRange = response.offRate;
			formattedData.groundDutyDetails.GIOfficeTrainingRange = response.giOfficeRate;
			formattedData.groundDutyDetails.MaxPayOfficeDuties = response.maxPayOfficeDutyRate;
			formattedData.groundDutyDetails.MaxPayOfficeDutyHoursPerDay=response.maxPayOfficeDutyHoursPerDay;
      formattedData.groundDutyDetails.CabinSpecialDutyPerHour=response.cabinSpecialDutyRate;
      formattedData.groundDutyDetails.CabinSupportActivityPerHour=response.cabinSupportActivityRate;

			// deadHeadingDutyDetails
			formattedData.deadHeadingDutyDetails.flightDutyDHDRange = response.duty1;
			formattedData.deadHeadingDutyDetails.heavyFlyingRange = response.heavyFlyingRate;
			formattedData.deadHeadingDutyDetails.deadHeadingTravelRange = response.dhtRate;

			// standByDutyDetails
			formattedData.standByDutyDetails.airportStandByRange = response.airPortSbyRate;
			formattedData.standByDutyDetails.calledFromOFFRange = response.calledFromOffRate;

			// leaveDetails
			formattedData.leaveDetails.leaveDaysRange = response.leaveDays;

			// adHocDetails
			formattedData.adHocDetails.adhocRange = response.adHocPay;

			formattedData.crewType = response.crewType;
			formattedData.version = response.version;
			formattedData.paymentRateId = response.paymentRateId;

			formattedData.cmbRate = response.cmbRate;
			formattedData.simRate = response.simRate;
			formattedData.sod = response.sod;
			formattedData.offRate = response.offRate;

			formattedData.simStandinRate = response.simStandinRate;

			formattedData.groundDutyDetails.groundTrainingRatePerDay = response.groundTrainingRatePerDay;

			return formattedData;
		}

		function FormatFlyingHourRatesRequest(request) {
			var tmpData = new FlyingHourRatesForSaveRequest();
			tmpData.rangeTitle = request.rangeTitle;
			tmpData.rangeStartHour = request.fromHour;
			tmpData.rangeEndHour = request.toHour;
			tmpData.flyHourRate = request.range;
			tmpData.paymentHourRangeId = request.paymentHourRangeId;
			tmpData.version = request.version;
			tmpData.crewTypeCode = request.crewTypeCode;

			return tmpData;

		}

		function FormatFlyingHourRatesRequestForDelete(request) {
			var tmpData = new FlyingHourRatesForDeleteRequest();
			tmpData.paymentHourRangeId = request.paymentHourRangeId;
			tmpData.version = request.version;

			return tmpData;

		}

		function FormatOtherPaymentRequestForSave(request) {

			var tmpData = new OtherPaymentRatesForSave();

			tmpData.paymentRateId = request.paymentRateId;
			tmpData.version = request.version;
			tmpData.crewType = request.crewType;

			tmpData.calledFromOffRate = request.standByDutyDetails.calledFromOFFRange;
			tmpData.airPortSbyRate = request.standByDutyDetails.airportStandByRange;

			tmpData.grdRate = request.groundDutyDetails.GRDTrainingRange;
			tmpData.offRate = request.groundDutyDetails.officeDutyRange;
			tmpData.giOfficeRate = request.groundDutyDetails.GIOfficeTrainingRange;
			tmpData.maxPayOfficeDutyRate = request.groundDutyDetails.MaxPayOfficeDuties;
			tmpData.maxPayOfficeDutyHoursPerDay=request.groundDutyDetails.MaxPayOfficeDutyHoursPerDay;
			tmpData.groundTrainingRatePerDay=request.groundDutyDetails.groundTrainingRatePerDay;
      tmpData.cabinSpecialDutyRate=request.groundDutyDetails.CabinSpecialDutyPerHour;
      tmpData.cabinSupportActivityRate=request.groundDutyDetails.CabinSupportActivityPerHour;

			tmpData.dhtRate = request.deadHeadingDutyDetails.deadHeadingTravelRange;
			tmpData.heavyFlyingRate = request.deadHeadingDutyDetails.heavyFlyingRange;
			tmpData.duty1 = request.deadHeadingDutyDetails.flightDutyDHDRange;

			tmpData.leaveDays = request.leaveDetails.leaveDaysRange;

			tmpData.adHocPay = request.adHocDetails.adhocRange;

			tmpData.domesticNightStopRate = request.layOverDetails.domesticLayoverRateRange;
      tmpData.hourlyDomesticNightStopRate = request.layOverDetails.hourlyDomesticLayOverDetails;
      tmpData.internationalNightStopRate = request.layOverDetails.internationalLayoverRate;
      tmpData.hourlyInternationalNightStopRate = request.layOverDetails.hourlyInternationalLayOverDetails;
      tmpData.hourlyDomesticPerDiemRate = request.layOverDetails.hourlyDomesticPerDiemRate;
      tmpData.hourlyInternationalPerDiemRate = request.layOverDetails.hourlyInternationalPerDiemRate;

			tmpData.ltRate = request.lineTraining.lineTrainingRange;
			tmpData.lt_LTC_LESS_EXP_Rate = request.lineTraining.LTLTCInExperiencedRange;
			tmpData.lt_LTC_MORE_EXP_Rate = request.lineTraining.LTLTCExperiencedRange;
			tmpData.lt_TRI_MORE_EXP_Rate = request.lineTraining.LTTRIExperiencedRange;
			tmpData.lt_TRI_LESS_EXP_Rate = request.lineTraining.LTTRIInExperiencedRange;
			tmpData.lt_TRE_LESS_EXP_Rate = request.lineTraining.LTTREInExperiencedRange;
			tmpData.lt_TRE_MORE_EXP_Rate = request.lineTraining.LTTREExperiencedRange;

			tmpData.sim_SFI_LESS_EXP_Rate = request.SIMHoursDetails.SIMFSIInExperiencedRange;
			tmpData.sim_SFI_MORE_EXP_Rate = request.SIMHoursDetails.SIMFSIExperiencedRange;
			tmpData.sim_TRI_LESS_EXP_Rate = request.SIMHoursDetails.SIMTRIInExperiencedRange;
			tmpData.sim_TRI_MORE_EXP_Rate = request.SIMHoursDetails.SIMTRIExperiencedRange;
			tmpData.sim_TRE_MORE_EXP_Rate = request.SIMHoursDetails.SIMTREExperiencedRange;
			tmpData.sim_TRE_LESS_EXP_Rate = request.SIMHoursDetails.SIMTREInExperiencedRange;
			tmpData.mftd_MORE_EXP_Rate = request.SIMHoursDetails.MFTDTrainerExperiencedRange;
			tmpData.mftd_LESS_EXP_Rate = request.SIMHoursDetails.MFTDTrainerInExperiencedRange;

			tmpData.sod = request.sod;
			tmpData.cmbRate = request.cmbRate;
			tmpData.simRate = request.simRate;

			tmpData.simStandinRate = request.simStandinRate;

			return tmpData;

		}

		return {
			formatFlyingHourRatesRequest : FormatFlyingHourRatesRequest,
			formatFlyingHourRatesResponse : FormatFlyingHourRatesResponse,
			formatFlyingHourRatesRequestForDelete : FormatFlyingHourRatesRequestForDelete,
			formatOtherPaymentRatesResponse : FormatOtherPaymentRatesResponse,
			formatOtherPaymentRequestForSave : FormatOtherPaymentRequestForSave
		}
	}
})();
